import { render, staticRenderFns } from "./TestsCat.vue?vue&type=template&id=79537cd7&"
import script from "./TestsCat.vue?vue&type=script&lang=js&"
export * from "./TestsCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports